import { Component, HostListener, OnInit } from '@angular/core';
import { Event, Router, NavigationStart, NavigationEnd, RouterOutlet } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { CommonService } from './services/common.service';
import { httpRoutes, httpVersion } from 'src/consts/http-routes';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from './authentication/authentication.service';
import { HttpCall } from './services/httpcall.service';
import { SocketService } from './socket.service';
import { ProcessCompleteDialogComponent } from './process-complete-dialog/process-complete-dialog.component';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PageLoaderComponent } from './layout/page-loader/page-loader.component';
import { swalWithBootstrapButtons } from 'src/consts/utils';
import { localStorageConstants } from 'src/consts/local-storage-constants';
import { sweetAlert } from 'src/consts/sweet_alert';
import { WEB_ROUTES } from 'src/consts/routes';
import Swal from 'sweetalert2';
import { BnNgIdleService } from 'bn-ng-idle';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [BnNgIdleService],
  imports: [RouterOutlet, PageLoaderComponent]
})
export class AppComponent implements OnInit {
  currentUrl!: string;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date;
  title = 'angular-idle-timeout';
  isSuperadmin = false;
  private idleSub: any;
  private warningTimer: any;
  constructor(private dialogRef: MatDialog,
    public translate: TranslateService,
    public _router: Router,
    public commonService: CommonService,
    private authenticationService:
      AuthenticationService,
    private httpCall: HttpCall,
    private socketService: SocketService,
    private location: Location,
    private snackBar: MatSnackBar,
    private bnIdle: BnNgIdleService

  ) {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    });
    this.translate.addLangs(['en', 'es']);
    this.translate.setDefaultLang('en');
    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf('/') + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
        /* empty */
      }
      window.scrollTo(0, 0);
    });
    this.updateIdealTimeout();
    const path = this.location.path();
    let pathSplit = path.split("/");
    if (pathSplit[1] === 'superadmin') {
      this.isSuperadmin = true;
    } else {
      this.isSuperadmin = false;
      this.checkApproverUser()
    }

  }
  ngOnInit(): void {
    if (this.isSuperadmin === false) {
      this.getInvoiceCounts();
      this.socketService.on('processComplete').subscribe((data) => {
        this.processCompleteDialog(data);
        this.getInvoiceCounts();
        // setTimeout(() => {
        //   window.location.reload();
        // }, 3000);
        //  alert(`Notification: ${data.message}`);
      });
    }
  }
  async getInvoiceCounts() {
    const data = await this.commonService.getRequestAPI(httpVersion.PORTAL_V1 + httpRoutes.GET_SIDEBAR_INVOICE_COUNT);
    if (data.status) {
      this.socketService.pendingInvoiceCount.next({ pending_invoices: data.data.pendingNew });

    }
  }
  processCompleteDialog(data: any) {
    this.snackBar.openFromComponent(ProcessCompleteDialogComponent, {
      data: {
        message: data.message
      },
      duration: 5000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
    });
  }

  checkApproverUser() {
    this.httpCall.httpGetCall(httpVersion.PORTAL_V1 + httpRoutes.CHECK_APPROVER).subscribe((checkApprover: any) => {
      if (checkApprover.status) {
        if (checkApprover.isApprover === false) {
          this.authenticationService.checkApproverUserSubject.next(false);
        } else {
          this.authenticationService.checkApproverUserSubject.next(true);
        }
      }
    });
  }

  async updateIdealTimeout() {
    if (localStorage.getItem(localStorageConstants.LOGOUT) === 'false') {
      const data = await this.commonService.getRequestAPI(
        httpVersion.PORTAL_V1 + httpRoutes.PORTAL_SMARTACCUPAY_INVOICE__SETTINGS_GET_ALL_ALERTS
      );

      // ✅ Do not run idle logic on locked screen
      if (this._router.url === '/authentication/locked') {
        console.log('Idle watcher skipped: already on locked screen');
        return;
      }

      if (data.status && data.data.settings.Auto_Log_Off.setting_status === 'Active') {
        const idleMinutes = Number(data.data.settings.Auto_Log_Off.setting_value);
        const idleSeconds = idleMinutes * 60;

        // Stop old watcher if running
        if (this.idleSub) {
          this.bnIdle.stopTimer();
          this.idleSub.unsubscribe();
          this.idleSub = null;
        }

        // Start idle watcher
        this.idleSub = this.bnIdle.startWatching(idleSeconds).subscribe((isTimedOut: boolean) => {
          if (isTimedOut) {
            this.idleState = 'Timed out!';
            this.timedOut = true;
            console.log(this.idleState);

            swalWithBootstrapButtons.close();
            this.dialogRef.closeAll();

            // 🛑 stop timers when locked
            if (this.idleSub) {
              this.bnIdle.stopTimer();
              this.idleSub.unsubscribe();
              this.idleSub = null;
            }
            if (this.warningTimer) {
              clearTimeout(this.warningTimer);
              this.warningTimer = null;
            }
            localStorage.setItem(localStorageConstants.LOGOUT, 'true');
            // Redirect to locked screen
            this._router.navigate(['/authentication/locked']);
          }
        });

        this.scheduleWarning(idleSeconds, idleMinutes);
        this.idleState = 'Started.';
        this.timedOut = false;
      }
    }

  }

  private scheduleWarning(idleSeconds: number, idleMinutes: number) {
    const warningBefore = 30; // seconds before timeout

    // Clear old timer
    if (this.warningTimer) {
      clearTimeout(this.warningTimer); // clear first using the stored ID
      this.warningTimer = null;        // then reset the variable
    }

    if (this._router.url === '/authentication/locked') {
      console.log('Idle watcher skipped: already on locked screen');
      return;
    }

    this.warningTimer = setTimeout(() => {
      swalWithBootstrapButtons.fire({
        title: 'Are you sure?',
        text: `You have been inactive for ${idleMinutes} minutes, your session is about to end due to inactivity.`,
        html: `As a security precaution, if there is no additional activity in your SmartAccuPay session, the session will end and you will be brought to the login page.</br></br>If you are still working please click OK to continue.`,
        showCancelButton: true,
        confirmButtonText: 'Logout',
        denyButtonText: "Lock screen",
        showDenyButton: true,
        allowOutsideClick: false,
        background: localStorage.getItem(localStorageConstants.DARKMODE) === 'dark'
          ? sweetAlert.DARK_BACKGROUND
          : sweetAlert.WHITE_BACKGROUND,
        color: localStorage.getItem(localStorageConstants.DARKMODE) === 'dark'
          ? sweetAlert.DARK_COLOR
          : sweetAlert.WHITE_COLOR,
      }).then((result) => {
        if (result.value) {
          this.logout();
          console.log('Logout pressed');
        } else if (result.isDismissed) {
          console.log('Stay logged in pressed');
          this.bnIdle.resetTimer(); // reset idle countdown
          swalWithBootstrapButtons.close();
          // 🔑 Re-schedule warning again
          this.scheduleWarning(idleSeconds, idleMinutes);
        }
      });
    }, (idleSeconds - warningBefore) * 1000);
  }

  logout() {
    this.authenticationService.changeLoginValue(true);
    this.authenticationService.changeTokenValue('');
    localStorage.removeItem(localStorageConstants.DARKMODE);
    localStorage.removeItem(localStorageConstants.USERDATA);
    localStorage.removeItem(localStorageConstants.COMPANYDATA);
    localStorage.removeItem(localStorageConstants.COMPANYID);
    localStorage.removeItem(localStorageConstants.INVOICE_GIF);
    localStorage.removeItem(localStorageConstants.INVOICE_TOKEN);
    localStorage.setItem(localStorageConstants.LOGOUT, 'true');
    localStorage.removeItem('choose_logoheader');
    localStorage.removeItem('choose_skin');
    localStorage.removeItem('menuOption');
    localStorage.removeItem('thinvoicetheme');
    this._router.navigate([WEB_ROUTES.LOGIN]);
    //   }
    // });
  }

  // Right click Off
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(e: KeyboardEvent) {
    console.log(e);

    // Check for the conditions for preventing default behavior
    if (e.key === 'F12' || (e.key === 'I' && (e.ctrlKey || e.metaKey) && e.shiftKey)) {
      e.preventDefault();
      // return; // Indicate that this is a void function
      return false;
    }

    if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'C' || e.key === 'J' || e.key === 'c' || e.key === 'j')) {
      e.preventDefault();
      return false;
      //return; // Indicate that this is a void function
    }

    if ((e.ctrlKey || e.metaKey) && e.key === 'U') {
      e.preventDefault();
      return false;
      //return; // Indicate that this is a void function
    }
    return true;
  }

}
